import {
  jb_bypass_block_css_default
} from "./chunk.F3VWX5ZH.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-bypass-block/jb-bypass-block.ts
var JbBypassBlock = class extends r {
  constructor() {
    super(...arguments);
    this._itemMapByHotkey = /* @__PURE__ */ new Map();
    this._itemMapByName = /* @__PURE__ */ new Map();
  }
  update(changedProperties) {
    super.update(changedProperties);
    this._itemMapByHotkey = /* @__PURE__ */ new Map();
    this.items.filter((item) => item.hotkey)?.forEach((item) => {
      this._itemMapByHotkey.set(this._mapKeyFromKey(item.hotkey), item);
    });
    this._itemMapByName = /* @__PURE__ */ new Map();
    this.items.forEach((item) => {
      this._itemMapByName.set(item.name, item);
    });
  }
  _handleBypass(bypassItemName) {
    const bypassItem = this._itemMapByName.get(bypassItemName);
    if (bypassItem.href) {
      window.location.href = bypassItem.href;
      return;
    }
    this.dispatchEvent(
      new CustomEvent("jb-bypass-block:navigate", {
        detail: { name: bypassItem.name, hotkey: bypassItem.hotkey },
        bubbles: true,
        composed: true
      })
    );
  }
  _handleKeyDown(evt) {
    if (evt.code === "Space") {
      evt.preventDefault();
      evt.target.click();
    } else {
      const validHotkeys = [...this._itemMapByHotkey.keys()];
      const key = this._mapKeyFromKey(evt.key);
      if (validHotkeys?.includes(key)) {
        this._handleBypass(this._itemMapByHotkey.get(key).name);
      }
    }
  }
  _handleMouseEventBypassBlock(evt) {
    const itemName = evt.target.dataset.name;
    this._handleBypass(itemName);
  }
  _mapKeyFromKey(key) {
    return `key${key.toUpperCase()}`;
  }
  render() {
    return ke`<div class="bypass-block">
      ${this.items.map(
      (item) => ke`${item.href ? ke`<a
                aria-label="${item.label}"
                data-name="${item.name}"
                data-hotkey="${item.hotkey ? item.hotkey : ""}"
                href="${item.href}"
                role="button"
                @click=${this._handleMouseEventBypassBlock}
                @keydown=${this._handleKeyDown}
              >
                ${item.label} ${item.hotkey ? `[${item.hotkey}]` : D}
              </a>` : ke`<button
                aria-label="${item.label}"
                data-name="${item.name}"
                data-hotkey="${item.hotkey ? item.hotkey : ""}"
                @click=${this._handleMouseEventBypassBlock}
                @keydown=${this._handleKeyDown}
              >
                ${item.label} ${item.hotkey ? `[${item.hotkey}]` : D}
              </button>`}`
    )}
    </div>`;
  }
};
JbBypassBlock.styles = [reset_css_default, jb_bypass_block_css_default];
__decorateClass([
  n({ type: Array })
], JbBypassBlock.prototype, "items", 2);
JbBypassBlock = __decorateClass([
  customElement("jb-bypass-block")
], JbBypassBlock);

export {
  JbBypassBlock
};
